module.exports = __webpack_public_path__ + "static/media/linkedin.569afac5.svg";